import React, { createContext, useState, useContext } from "react";

const SelectedObjectContext = createContext(undefined);

export function SelectedObjectProvider({ children }) {
  const [selectedObject, setSelectedObject] = useState({
    name: "Seçili Obje Yok",
    filter: null,
    itemId: null,
    error: 0,
    warning: 0,
    online: 0,
    offline: 0,
  });

  return (
    <SelectedObjectContext.Provider
      value={{ selectedObject, setSelectedObject }}
    >
      {children}
    </SelectedObjectContext.Provider>
  );
}

export function useSelectedObject() {
  const ctx = useContext(SelectedObjectContext);
  if (!ctx) {
    // Fallback to a benign default to avoid runtime crashes when provider is missing
    return {
      selectedObject: {
        name: "",
        filter: null,
        itemId: null,
        error: 0,
        warning: 0,
        online: 0,
        offline: 0,
      },
      setSelectedObject: () => {},
    };
  }
  return ctx;
}
